<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h5 style="margin-bottom: 0px;">REPORTES</h5>
            <h6 style="margin-top: 0px;">Reporte Consulta de Documentos</h6>
        </div>
        <div style="display: flex">
            <div class="col-12 padding-0">
                <div class="area" style="margin-top: 0px">
                    <div class="row">
                            <div class="form-group col-2">
                                <label>Año:</label>
                                <input class="form-control" type="Number" v-model="Busqueda.Anio">
                            </div>
                            <div class="form-group col-1" style="margin-top: 26px;">
                                <button class="btn btn-sm btn-dark" @click='ObtenerReporte()'>Generar Reporte</button>
                            </div>
                    </div>
                </div>
                <div class="area" style="margin-top: 0px" v-if="DatosTabla.length > 0" id="resultado_div">
                    <div id="Volumen_table" class="table-reponsive">
                        <table class="table table-striped table-light table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Área</th>
                                        <th>Sede</th>
                                        <th>Ene</th>
                                        <th>Feb</th>
                                        <th>Mar</th>
                                        <th>Abr</th>
                                        <th>May</th>
                                        <th>Jun</th>
                                        <th>Jul</th>
                                        <th>Ago</th>
                                        <th>Sep</th>
                                        <th>Oct</th>
                                        <th>Nov</th>
                                        <th>Dic</th>
                                        <th>Ʃ</th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark" v-for="datos in DatosTabla">
                                    <tr>
                                        <td v-bind:rowspan="datos.grSede.length + 1"> <strong> {{ datos.AreaNombre }} </strong></td>
                                    </tr>
                                    <tr v-for="detalle in datos.grSede">
                                        <td>{{detalle.NombreLugar}}</td>
                                        <td class="text-right">{{detalle.Enero}}</td>
                                        <td class="text-right">{{detalle.Febrero}}</td>
                                        <td class="text-right">{{detalle.Marzo}}</td>
                                        <td class="text-right">{{detalle.Abril}}</td>
                                        <td class="text-right">{{detalle.Mayo}}</td>
                                        <td class="text-right">{{detalle.Junio}}</td>
                                        <td class="text-right">{{detalle.Julio}}</td>
                                        <td class="text-right">{{detalle.Agosto}}</td>
                                        <td class="text-right">{{detalle.Septiembre}}</td>
                                        <td class="text-right">{{detalle.Octubre}}</td>
                                        <td class="text-right">{{detalle.Noviembre}}</td>
                                        <td class="text-right">{{detalle.Diciembre}}</td>
                                        <td class="text-right"><strong>{{detalle.Total}}</strong></td>
                                    </tr>
                                </tbody>
                                <tbody class="text-dark">
                                    <tr>
                                        <td></td>
                                        <td class="text-right"><strong>Totales</strong></td>
                                        <td class="text-right"><strong>{{this.TotalEnero}}</strong></td> 
                                        <td class="text-right"><strong>{{this.TotalFebrero}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalMarzo}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalAbril}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalMayo}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalJunio}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalJulio}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalAgosto}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalSeptiembre}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalOctubre}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalNoviembre}}</strong></td>
                                        <td class="text-right"><strong>{{this.TotalDiciembre}}</strong></td>
                                        <td class="text-right"><strong>{{this.Grantotal}}</strong></td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>
                    <div >
                        <Grafica :options="chartOptions" style="min-height:400px; max-width:960px;"></Grafica>
                    </div>
                </div>
                <div class="area" v-if="DatosTabla.length > 0">
                    <div class="text-right">
                        <button class="btn btn-sm btn-dark" @click='ImprimirReporte()' >Imprimir Reporte</button>      
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import highcharts from '@/../static/js/highchart'
import LogoPJE from '@/../src/assets/logo-pj-transparente-negro.png'

export default {
    components: {
        Grafica : highcharts
    },
    data(){
        return{
            Busqueda: {
                Anio: parseInt(moment().format('YYYY'))
            },
            DatosTabla: [],
            chartOptions: {
                chart: {
                    type: 'column'
                },
                title: {
                    text: 'Grafica de Solicitudes'
                },
                lang: {
                    viewFullscreen: "Ver en pantalla completa",
                    printChart: "Imprimir gráfica",
                    downloadJPEG: "Descargar imagen JPEG",
                    downloadPDF: "Descargar documento PDF",
                    downloadPNG: "Descargar imagen PNG",
                    downloadSVG: "Descargar imagen SVG"
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ''
                    }
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    pointFormat: 'Documentos: <b>{point.y:.1f}</b>'
                },
                series: [{
                    name: 'Documentos',
                    color : '#000000',
                    data: [
                        ['Enero', 200],
                        ['Febrero', 150],
                        ['Marzo', 142],
                        ['Abril', 56],
                        ['Mayo', 210],
                        ['Junio', 12],
                        ['Julio', 35],
                        ['Agosto', 85],
                        ['Septiembre', 0],
                        ['Octubre', 56],
                        ['Noviembre', 190],
                        ['Diciembre', 112]
                    ],
                    dataLabels: {
                        enabled: true,
                        rotation: -90,
                        color: '#FFFFFF',
                        align: 'right',
                        format: '{point.y:.1f}', // one decimal
                        y: 10, // 10 pixels down from the top
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                        }
                    }
                ]
            } 
        }
    },
    methods :{
        ObtenerReporte(){
            if(this.ValidarDatos())
            {
                var peticion = {
                    
                    "Año": this.Busqueda.Anio
                }
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.UsuariosAnual, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                        if(respuesta.data.SiHayError)
                        {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        }
                        else
                        {   
                            this.DatosTabla = respuesta.data.Solicitudes;
                            

                            let Arreglo = [];
                            Arreglo.push(["Enero", this.TotalEnero]);
                            Arreglo.push(["Febrero", this.TotalFebrero]);
                            Arreglo.push(["Marzo", this.TotalMarzo]);
                            Arreglo.push(["Abril", this.TotalAbril]);
                            Arreglo.push(["Mayo", this.TotalMayo]);
                            Arreglo.push(["Junio", this.TotalJunio]);
                            Arreglo.push(["Julio", this.TotalJulio]);
                            Arreglo.push(["Agosto", this.TotalAgosto]);
                            Arreglo.push(["Septiembre", this.TotalSeptiembre]);
                            Arreglo.push(["Octubre", this.TotalOctubre]);
                            Arreglo.push(["Noviembre", this.TotalNoviembre]);
                            Arreglo.push(["Diciembre", this.TotalDiciembre]);
                            
                            this.chartOptions.series[0].data = Arreglo;
                            this.chartOptions.title.text = "Consulta de Expedientes a Usuarios en  " + this.Busqueda.Anio;
                            this.chartOptions.yAxis.title.text = "Documentos";

                            comun.SeEstaCargandoInformacion(false);
                            if(this.DatosTabla.length <=0)
                            {
                                comun.mensajeDeAlerta("No hay resultados en reporte para el año seleccionado", null, null);
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                        })
                        .catch(excepcion => {
                            console.log(excepcion);
                            console.log("fallo por parametros");
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false);
                        }); 
            }
        },
        ValidarDatos(){
            if(this.Busqueda.Anio == 0 || this.Busqueda.Anio == null)
            { comun.mensajeDeAlerta("Indicar año de ingreso correcto.", null, null);
                    return false;
            };
            
            if(this.Busqueda.Anio >parseInt(moment().format('YYYY')))
            { comun.mensajeDeAlerta("El año de ingreso no puede ser mayor al año corriente", null, null);
                    return false;
            };
            
            return true; 
        },
        ImprimirReporte(){
          var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div style="display: flex">');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">SOLICITUDES ANUAL USUARIOS</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('</div>');

            printWin.document.write('<div class="area">');
            
            var areaImpresion = document.getElementById('resultado_div').innerHTML;
            printWin.document.write(areaImpresion);
            
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        }
    },
    computed : {
        TotalEnero : function(){
            
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Enero;
                })
                return total + Suma;
            },0)
        },
        TotalFebrero: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Febrero;
                })
                return total + Suma;
            },0)
        },
        TotalMarzo: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Marzo;
                })
                return total + Suma;
            },0)
        },
        TotalAbril: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Abril;
                })
                return total + Suma;
            },0)
        },
        TotalMayo: function(){
           return this.DatosTabla.reduce(function(total, item){
            var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    
                    Suma += grSede.Mayo;
                })
                return total + Suma;          
            },0)
        },
        TotalJunio: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Junio;
                })
                return total + Suma;
            },0)
        },
        TotalJulio: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Julio;
                })
                return total + Suma;
            },0)
        },
        TotalAgosto: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Agosto;
                })
                return total + Suma;
            },0)
        },
        TotalSeptiembre: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Septiembre;
                })
                return total + Suma;
            },0)
        },
        TotalOctubre: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Octubre;
                })
                return total + Suma;
            },0)
        },
        TotalNoviembre: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Noviembre;
                })
                return total + Suma;
            },0)
        },
        TotalDiciembre: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Diciembre;
                })
                return total + Suma;
            },0)
        },
        Grantotal: function(){
            return this.DatosTabla.reduce(function(total, item){
                var Suma = 0;
                $.each(item.grSede, function(index, grSede)
                {
                    Suma += grSede.Total;
                })
                return total + Suma;
            },0)
        }
        // Title(){
        //     if(this.Ingreso == true && this.Solicitud == false)
        //     {return "Reporte de Ingreso de Documentos"} 
        //     if(this.Ingreso == false && this.Solicitud == false)
        //     {return "Reporte de Reingreso de Documentos"}
        //     if(this.Ingreso == false && this.Solicitud == true)
        //     {
        //         {return "Reporte Solicitudes"}
        //     }
        // }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Reportes/UsuariosAnual.vue